import { Box } from '@mui/material'
import { t } from 'i18next'
import React from 'react'
import { useForm } from 'react-hook-form'
import { Button } from 'src/Common/ui/button'
import DatePickerInput from 'src/Common/ui/DatePickerInput'
import { indTimeConvert } from 'src/lib/utils'

export default function DateRange ({ handleApply, activeCalendarDate, from, to, handleDateChange }) {
    const { control, errors, register } = useForm({})
    const calMax = () => {
        const date = new Date(activeCalendarDate)
        const activeDate = new Date(date.getFullYear(), date.getMonth() + 1, 0)
        return activeDate
    }
    return (
        <>
            <Box className="w-full" display="grid" gridTemplateColumns="1fr 1fr 0.5fr" gap={4}>
                <Box >

                    <DatePickerInput
                        control={control}
                        required
                        name='fromDateForm'
                        label={t('From')}
                        type="number"
                        errors={errors}
                        register={register}
                        value={from}
                        onValueChange={(e) => { handleDateChange(e, 'from') }}
                        minDate={indTimeConvert(new Date())}
                    />
                </Box>
                <Box >
                    <DatePickerInput
                        control={control}
                        required
                        name='fromDateTo'
                        label={t('To')}
                        type="number"
                        errors={errors}
                        register={register}
                        value={to}
                        onValueChange={(e) => { handleDateChange(e, 'to') }}
                        minDate={indTimeConvert(new Date(from))}
                        maxDate={indTimeConvert(calMax())}
                    />
                </Box>
                <Box className='w-full flex justify-end items-end' >
                    <Button onClick={handleApply} disabled={!from || !to} >Apply</Button>
                </Box>
            </Box>
        </>
    )
}
